import React from "react";
import ReactDOM from "react-dom";
import Routes from "./routes/index";
import "bootstrap/dist/css/bootstrap.css";

ReactDOM.render(
  <div>
    <Routes />
  </div>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js